import dayjs from "dayjs";

export const getRevNoColumns = (page = 1, limit = 10) => [
  {
    title: "Sr. No.",
    key: "srNo",
    width: 80,
    align: "center",
    render: (_, __, index) => (page - 1) * limit + index + 1,
  },
  {
    title: "IO No",
    dataIndex: "IO_NO",
    key: "IO_NO",
    width: 180,
  },
  {
    title: "Old Rev No",
    dataIndex: "OLD_REV_NO",
    key: "OLD_REV_NO",
    align: "center",
    width: 120,
  },
  {
    title: "New Rev No",
    dataIndex: "NEW_REV_NO",
    key: "NEW_REV_NO",
    align: "center",
    width: 120,
  },
  {
    title: "Rows Updated",
    dataIndex: "ROWS_AFFECTED",
    key: "ROWS_AFFECTED",
    align: "center",
    width: 140,
  },
  {
    title: "Changed By",
    dataIndex: "CHANGED_BY",
    key: "CHANGED_BY",
    width: 140,
  },
  {
    title: "Changed At",
    dataIndex: "CHANGED_AT",
    key: "CHANGED_AT",
    width: 200,
    render: (value) =>
      value ? dayjs(value).format("DD MMM YYYY, hh:mm A") : "-",
  },
];